
import React from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { useDispatch } from "react-redux";
import instance from "../../utils/axios";
import { getApiUrl } from "../../utils/apiUrls";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { apiErrorHandler } from "../../utils/errorHandler";
import CustomButtonLoader from "../../components/global/CustomButtonLoader.component";
const DownloadButton = ({ 
  t, 
  type, 
  fileExtention, 
  eventId, 
  documentId, 
  documentName, 
  extensionKey, 
  envState,
  isOtherLoading,
  documentString
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(false);
  
  const handleDownload = async (type) => {
    setIsLoading(true);
    try {
      const res = await instance.get(
        `${getApiUrl(
          envState.PRODUCTION
            ? "downloadDocumentFile"
            : "viewDownloadDocumentFileLocal"
        )}/${eventId}/${documentId}/${documentString}/DOWNLOAD`, envState.PRODUCTION ? {
          responseType: "blob",
        } : {}
      );
      if (envState.PRODUCTION) {
        const blob = new Blob([res.data], { type: extensionKey[fileExtention] });
        saveAs(blob, documentName);
      }
      else {
        await axios.get(res.data)
        saveAs(res.data, documentName);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      if (envState.PRODUCTION) {
        const errorMes = new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onload = () => {
            err.response.data = JSON.parse(reader.result);
            const msgObj = apiErrorHandler(err);
            dispatch(
              openSnackBar({
                msg: t(msgObj.statusText),
                type: "error",
              })
            );
            resolve(Promise.reject(err));
          };

          reader.onerror = () => {
            reject(err);
          };
          reader.readAsText(err.response.data);
        });
      }
      else {
        const msgObj = apiErrorHandler(err);
        dispatch(
          openSnackBar({
            msg: t(msgObj.statusText),
            type: "error",
          })
        );
      }
    }
  };

  return (
    <CustomButtonLoader
      showLoadingState={isLoading}
      colorTheme="hoverBlue"
      icon={null}
      reverseIconDirection={false}
      buttonLabel={
        fileExtention === "zip" ? t("download") : t("download_file")
      }
      disabled={isOtherLoading}
      buttonStyle={"px-12 py-2 cm-mar-left-icon"}
      handleOnClick={handleDownload}
    />
  );
};
export default DownloadButton;
